import Button from '@components/Button/Button'
import { useTranslation } from 'react-i18next'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import styles from './ResetPin.module.scss'
import OTPInput from '@/components/OtpInput/OtpInput'
import Keyboard from '@/components/Keyboard/Keyboard'
import { PIN_RESETTING_STEPS } from './models/pinResettingSteps.model'
import { useSnackbar } from '@/components/Snackbar/SnackbarProvider'

function ResetPin() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { showSnackbar } = useSnackbar()

  const [otp, setOtp] = useState('')
  const [title, setTitle] = useState(
    t('AUTHORIZATION.REGISTER.CONFIRMATION_CODE_STEP.TITLE')
  )

  const setOtpValue = (digit: number) => {
    if (otp.length < 6) {
      setOtp(prev => prev + digit.toString())
    }
  }

  const clearOtpValue = () => {
    setOtp('')
  }

  const deleteLastOtpDigit = () => {
    setOtp(prev => prev.slice(0, -1))
  }

  useEffect(() => {
    if (otp.length === 6) {
      if (step === PIN_RESETTING_STEPS.CONFIRMATION_CODE) {
        if (otp === '123456') {
          setOtp('')
          setStep(PIN_RESETTING_STEPS.PIN)
          setTitle(t('AUTHORIZATION.REGISTER.PIN_STEP.TITLE'))
        } else {
          showSnackbar(
            t(
              'AUTHORIZATION.REGISTER.CONFIRMATION_CODE_STEP.VALIDATION.INVALID'
            ),
            'error'
          )
          setOtp('')
        }
      } else if (step === PIN_RESETTING_STEPS.PIN) {
        if (otp === '123456') {
          setOtp('')
          setStep(PIN_RESETTING_STEPS.CONFIRMATION_PIN)
          setTitle(t('AUTHORIZATION.REGISTER.CONFIRMATION_PIN_STEP.TITLE'))
        } else {
          showSnackbar(
            t('AUTHORIZATION.REGISTER.PIN_STEP.VALIDATION.INVALID'),
            'error'
          )
          setOtp('')
        }
      } else if (step === PIN_RESETTING_STEPS.CONFIRMATION_PIN) {
        if (otp === '123456') {
          handleFinalSuccess()
        } else {
          showSnackbar(
            t(
              'AUTHORIZATION.REGISTER.CONFIRMATION_PIN_STEP.VALIDATION.INVALID'
            ),
            'error'
          )
          setOtp('')
        }
      }
    }
  }, [otp])

  const [step, setStep] = useState(
    () =>
      sessionStorage.getItem('pinResettingStep') ||
      PIN_RESETTING_STEPS.CONFIRMATION_CODE
  )

  useEffect(() => {
    sessionStorage.setItem('pinResettingStep', step)
  }, [step])

  const handleFinalSuccess = () => {
    sessionStorage.removeItem('pinResettingStep')
    navigate('/tables-list')
  }

  const handlePrev = () => {
    if (step === PIN_RESETTING_STEPS.CONFIRMATION_PIN) {
      setStep(PIN_RESETTING_STEPS.PIN)
      setTitle(t('AUTHORIZATION.REGISTER.PIN_STEP.TITLE'))
    } else if (step === PIN_RESETTING_STEPS.PIN) {
      setStep(PIN_RESETTING_STEPS.CONFIRMATION_CODE)
      setTitle(t('AUTHORIZATION.REGISTER.CONFIRMATION_CODE_STEP.TITLE'))
    } else if (step === PIN_RESETTING_STEPS.CONFIRMATION_CODE) {
      navigate('/login')
    }
  }

  return (
    <div className={`${styles.resetPinContainer}`}>
      <h1 className={`title-bold-medium ${styles.resetPinHeader}`}>{title}</h1>

      <OTPInput setOtp={setOtp} otp={otp} />

      <Keyboard
        setValue={setOtpValue}
        clearValue={clearOtpValue}
        deleteValue={deleteLastOtpDigit}
      />

      <div className={`${styles.resetPinFormButtonContainer}`}>
        <Button
          onClick={handlePrev}
          label={t('AUTHORIZATION.REGISTER.PREV')}
          variant="contained"
          color="secondary"
          maxWidth
          mobile
        />
      </div>
    </div>
  )
}

export default ResetPin
